module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('xbanner'), _vm._v(" "), _c('xhot'), _vm._v(" "), _c('xcommend'), _vm._v(" "), _c('xcolumn'), _vm._v(" "), _c('xchosen'), _vm._v(" "), _c('xzhuanlang'), _vm._v(" "), _c('xplay')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fde26c8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/newSong.vue
// module id = 269
// module chunks = 0